<template>
  <div>
    <PageHeader>
      <template slot="right">
        <div>
          <b-button
            variant="primary"
            to="/bank-truewallet/create"
          >
            <i class="uil-plus mr-1"></i>
            {{ $t('buttons.add') }}
          </b-button>
        </div>
      </template>
    </PageHeader>
    <b-card>
      <div class="d-flex justify-content-between align-items-center">
        <h5>
          {{ `บัญชีทรูวอลเล็ท (${bankAccounts.length})` }}
        </h5>
      </div>
      <br />
      <b-table
        :items="bankAccounts"
        :fields="fields"
        :busy="isLoading"
        responsive
        show-empty
      >
        <template #cell(bank_code)="data">
          {{ $displayBankName(data.value) }}
        </template>
        <template #cell(limit)="data">
          {{ data.value | currency }}
        </template>
        <template #cell(is_enable)="data">
          <b-badge :variant="data.value ? 'success' : 'danger'">
            {{
              data.value
                ? $t(`utils.status.active`)
                : $t(`utils.status.inactive`)
            }}
          </b-badge>
        </template>
        <template #cell(id)="data">
          <b-dropdown
            variant="info"
            size="sm"
            dropleft
          >
            <template #button-content>
              <i class="uil uil-cog"></i>
            </template>
            <b-dropdown-item @click="onSelect(data.item)">
              <i class="uil uil-edit-alt mr-2"></i>
              {{ $t('buttons.edit') }}
            </b-dropdown-item>
            <b-dropdown-item
              variant="danger"
              @click="onDelete(data.item)"
            >
              <i class="uil uil-trash-alt mr-2"></i>
              <span>
                {{ $t('buttons.remove') }}
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
        <template #empty="">
          <p class="text-center text-muted">{{
            $t('messages.nothing_here')
          }}</p>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
      <!-- pagination -->
      <PaginationInput :per-page="limit" :total="totalRow" @update="(val) => currentPage = val"/>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CoreBankService from '../../../services/bank'

export default {
  page: {
    title: 'Bank Truewallet',
  },
  data() {
    return {
      currentPage: 1,
      limit: 50,
      offset: 0,
      isLoading: false,
      fields: [
        {
          key: 'username',
          label: 'เบอร์',
          thStyle: {},
        },
        {
          key: 'full_name',
          label: 'ชื่อจริง',
        },
        {
          key: 'balance',
          label: 'ยอดคงเหลือ',
        },
        {
          key: 'enabled',
          label: 'สถานะ',
        },
        {
          key: 'id',
          label: 'แก้ไข',
        },
      ],
      userBankAccounts: {
        data: [],
      },
    }
  },
  computed: {
    ...mapState(['user']),
    bankAccounts() {
      return this.userBankAccounts.data || []
    },
    totalRow() {
      return this.userBankAccounts.total
    },
  },
  watch: {
    currentPage(val) {
      const nextPage = val - 1
      this.offset = nextPage * this.limit + 1
      this.fetchData()
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.isLoading = true
      try {
        this.userBankAccounts = await CoreBankService.fetchTruewallet()
      } catch (e) {
        await this.$store.dispatch('notifyError', e)
      }
      this.isLoading = false
    },
    navigateRoute(value) {
      this.$router.push(`/bank-accounts/detail/${value.id}`)
    },
    deleteBankAccount() {
    },
    async onDelete(data) {
      this.isLoading = true
      try {
        await CoreBankService.removeTrueWalletAccount(data.id)
      } catch (e) {
        await this.$store.dispatch('notifyError', e)
      }
      this.isLoading = false
    },
    onSelect(data) {
      this.$router.push(`/bank-truewallet/${data.id}`)
    },
  },
}
</script>
